import React, { useState } from 'react';
import ZeroCountHelp from './ZeroCountHelp'; // Make sure to import the ZeroCountHelp component

const styles = {
  banner: {
    padding: '10px',
    margin: '16px 0',
    backgroundColor: '#3E3A31',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '8px', 
    border: '1px solid #FFA500'
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: '#3E3A31',
    border: '2px solid #FFA500',
    marginRight: '8px',
  },
  iconText: {
    fontWeight: 'bold',
    color: '#FFA500'
  },
  heading: {
    margin: '0 16px 0 0',
    padding: '8px',
  },
  button: {
    backgroundColor: '#242727',
    color: '#FFFFFF',
    border: 'none',
    padding: '8px 12px',
    cursor: 'pointer',
    borderRadius: '8px', 
    marginLeft: 'auto', 
  },
  closeButton: {
    backgroundColor: 'transparent',
    color: '#FFFFFF',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
  },
};

const ZeroCountBanner: React.FC = () => {
  const [visible, setVisible] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleClose = () => {
    setVisible(false);
  };

  const toggleDrawer = (open: boolean) => {
    setDrawerOpen(open);
  };

  if (!visible) return null;

  return (
    <>
      <div style={styles.banner}>
        <div style={styles.textContainer}>
          <div style={styles.iconContainer}>
            <span style={styles.iconText}>!</span>
          </div>
          <p style={{ margin: 0 }}>Looks like the query returned zero users.</p>
        </div>
        <button style={styles.button} onClick={() => toggleDrawer(true)}>Help me resolve this</button>
        <button style={styles.closeButton} onClick={handleClose}>✕</button>
      </div>
      <ZeroCountHelp open={drawerOpen} toggleDrawer={toggleDrawer} />
    </>
  );
};

export default ZeroCountBanner;